import { getPrefixedEventKey } from '@okee-uikit/react-hooks';
var animationEndEvents = getPrefixedEventKey('AnimationEnd');
var animationStartEvents = getPrefixedEventKey('AnimationStart');
var transitionEndEvents = getPrefixedEventKey('TransitionEnd');
var transitionStartEvents = getPrefixedEventKey('TransitionStart');
export function addAnimationEndListener(element, listener) {
  animationEndEvents.forEach(function (event) {
    return element.addEventListener(event, listener);
  });
}
export function removeAnimationEndListener(element, listener) {
  animationEndEvents.forEach(function (event) {
    return element.removeEventListener(event, listener);
  });
}
export function addAnimationStartListener(element, listener) {
  animationStartEvents.forEach(function (event) {
    return element.addEventListener(event, listener);
  });
}
export function removeAnimationStartListener(element, listener) {
  animationStartEvents.forEach(function (event) {
    return element.removeEventListener(event, listener);
  });
}
export function addTransitionEndListener(element, listener) {
  transitionEndEvents.forEach(function (event) {
    return element.addEventListener(event, listener);
  });
}
export function removeTransitionEndListener(element, listener) {
  transitionEndEvents.forEach(function (event) {
    return element.removeEventListener(event, listener);
  });
}
export function addTransitionStartListener(element, listener) {
  transitionStartEvents.forEach(function (event) {
    return element.addEventListener(event, listener);
  });
}
export function removeTransitionStartListener(element, listener) {
  transitionStartEvents.forEach(function (event) {
    return element.removeEventListener(event, listener);
  });
}